export interface ScrollPosition {
    scrollLeft: number;
    offsetWidth: number;
    scrollWidth: number;
}
